import { inr } from "@/lib/api";

export const RoomBreakdown = ({ rooms }) => (
  <div className="space-y-5" data-testid="quote-room-breakdown">
    {rooms.map((r, i) => (
      <div key={i} className="rounded-2xl border border-brand-line bg-brand-cream overflow-hidden" data-testid={`quote-room-${i}`}>
        <div className="flex justify-between items-center px-6 py-4 bg-brand-sand">
          <p className="font-serif-display text-2xl text-brand-ink">{r.name} <span className="text-sm font-sans text-brand-muted-light">· {r.area_sqft} sq.ft</span></p>
          <p className="font-mono-num text-sm text-brand-ink">{inr(r.subtotal)}</p>
        </div>
        <ul className="divide-y divide-brand-line">
          {r.items.map((it) => (
            <li key={it.name} className="flex justify-between px-6 py-3 text-sm">
              <span className="text-brand-muted">{it.name}<span className="text-brand-muted-light text-xs"> · {it.unit === "sqft" ? `${it.qty} sq.ft` : "1 unit"}</span></span>
              <span className="font-mono-num text-brand-ink">{inr(it.amount)}</span>
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
);

export const TotalsCard = ({ q }) => (
  <div className="rounded-2xl bg-brand-ink-soft text-brand-cream p-7 grain relative" data-testid="quote-totals-card">
    {[["Interior works", q.subtotal], [`Design & PM (${Math.round((q.design_fee_pct ?? 0.06) * 100)}%)`, q.design_fee], [`GST (${Math.round((q.gst_pct ?? 0.18) * 100)}%)`, q.gst]].map(([l, v]) => (
      <div key={l} className="flex justify-between text-sm py-2 text-brand-line"><span>{l}</span><span className="font-mono-num">{inr(v)}</span></div>
    ))}
    <div className="border-t border-white/15 mt-3 pt-5">
      <p className="text-[10px] uppercase tracking-[0.2em] text-brand-muted-light">Grand total</p>
      <p className="font-serif-display text-5xl mt-1" data-testid="quote-grand-total">{inr(q.total)}</p>
      <p className="text-xs text-brand-muted-light mt-2">≈ {inr(q.total / Math.max(q.total_area, 1))} per sq.ft · {q.timeline_weeks} weeks delivery</p>
    </div>
  </div>
);

export const PaymentSchedule = ({ items }) => (
  <div className="rounded-2xl border border-brand-line p-6" data-testid="quote-payment-schedule">
    <p className="text-xs uppercase tracking-[0.2em] text-brand-accent mb-4">Payment schedule</p>
    {items.map((p) => (
      <div key={p.stage} className="flex justify-between text-sm py-2">
        <span className="text-brand-muted">{p.stage} <span className="text-brand-muted-light">({p.pct}%)</span></span>
        <span className="font-mono-num text-brand-ink">{inr(p.amount)}</span>
      </div>
    ))}
  </div>
);
